import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";

export default function NavSocialMedia({ currentPage = "captions" }) {
  const { user } = useAuth();

  return (
    <div>
      <ul
        className="nav nav-tabs mb-4 justify-content-center justify-content-sm-start border-bottom"
        role="tablist"
      >
        {user.limitedexperience == null && (
          <>
            <li className="nav-item" role="presentation">
              <Link to="/social-media" className={`nav-link ${currentPage === "social-media" ? "active" : ""}`}>
                <i className="fi fi-rr-calendar"></i>
                <span className="d-none d-md-inline-block ms-2">Calendar</span>
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link to="/captions" className={`nav-link ${currentPage === "captions" ? "active" : ""}`}>
                <i className="fi fi-rr-text"></i>
                <span className="d-none d-md-inline-block ms-2">Captions</span>
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link to="/images" className={`nav-link ${currentPage === "images" ? "active" : ""}`}>
                <i className="fi fi-rr-picture"></i>
                <span className="d-none d-md-inline-block ms-2">Photos</span>
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link to="/videos" className={`nav-link ${currentPage === "videos" ? "active" : ""}`}>
                <i className="fi fi-rr-film"></i>
                <span className="d-none d-md-inline-block ms-2">Videos</span>
              </Link>
            </li>
          </>
        )}
        <li className="nav-item" role="presentation">
          <Link to="/stories" className={`nav-link ${currentPage === "stories" ? "active" : ""}`}>
            <i className="fi fi fi-rr-layout-fluid"></i>
            <span className="d-none d-md-inline-block ms-2">Stories</span>
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to="/carousels" className={`nav-link ${currentPage === "carousels" ? "active" : ""}`}>
            <i className="fi fi-rr-copy-image"></i>
            <span className="d-none d-md-inline-block ms-2">Carousels</span>
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to="/reels" className={`nav-link ${currentPage === "reels" ? "active" : ""}`}>
            <i className="fi fi-rr-play-alt"></i>
            <span className="d-none d-md-inline-block ms-2">Reels</span>
          </Link>
        </li>
        {user.limitedexperience == null ? (
          <li className="nav-item" role="presentation">
            <Link to="/content-vault" className={`nav-link ${currentPage === "content-vault" ? "active" : ""}`}>
              <i className="fi fi-rr-copy-image"></i>
              <span className="d-none d-md-inline-block ms-2">Content Vault</span>
            </Link>
          </li>
        ) : null}
        <li className="nav-item" role="presentation">
          <Link to="/all-bonuses" className={`nav-link ${currentPage === "all-bonuses" ? "active" : ""}`}>
            <i className="fi fi-rr-star" />
            <span className="d-none d-md-inline-block ms-2">Bonuses</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}